import React, { useState } from 'react';
import { get, isEmpty, isNil } from 'lodash';
import moment from 'moment';
import { toast } from 'react-toastify';
import { TextField } from '@material-ui/core';
import { IntlShape, injectIntl } from 'react-intl';
import { StyledDiv } from 'containers/CourtManagerLegalProceedings/ExpertiseExpert/Dialog/styles';
import DecisionDialog from 'components/DecisionDialog/index';
import { translate } from 'containers/services/translate';
import messages from 'containers/CourtManagerLegalProceedings/ExpertiseExpert/messages';
import { MISSION_EXPERISE_VICTIM_STATUS } from 'containers/data-structure';
import currentUserStorage from 'containers/services/security/current-user-storage';
import {
  EXPERTISE_ACCOUNTING_ID,
  EXPERTISE_MECHANIC_ID,
} from 'containers/CourtManagerLegalProceedings/constants';
import * as featureService from 'features/fflip-helpers';
import { FEATURES } from 'features/features';
import { getExpertiseSagisEvaluationTransaction } from 'containers/CourtManagerLegalProceedings/ExpertiseExpert/ExpertReport/utils';

export interface ValidationDialogProps {
  intl: IntlShape;
  open: boolean;
  onClose: Function;
  validateDialog: Function;
  recap: any;
  claimNumber: string;
  setOpenFeeNoteDialog: Function;
  transactionId?: boolean;
  timelineId?: any;
  allExpertReport?: any;
  responsibilityShare?: any;
  victims?: any;
  lossDate?: any;
  riskKey?: any;
}

const ValidationDialog: React.FC<ValidationDialogProps> = (
  props,
): JSX.Element => {
  const { onClose, open } = props;
  const [comment, setComment] = useState('');
  const handleChangeComment = (event: any) => {
    setComment(event.target.value);
  };
  /* istanbul ignore next */
  const successCallBack = () => {
    toast.success(translate(messages.toastValidationSuccess, props));
    props.onClose();
    if (featureService.hasFeature(FEATURES.EVOLUTIONS_FEE_NOTE)) {
      props.setOpenFeeNoteDialog(true);
    }
  };
  const handleValidate = () => {
    props.validateDialog(
      {
        status: MISSION_EXPERISE_VICTIM_STATUS.VALIDATED,
        id: get(props.recap, 'id'),
        decidedBy: currentUserStorage.get().username,
        expertCode: get(props.recap, 'createdBy'),
        decisionComment: comment,
        claimId: get(props.recap, 'claimId'),
        claimNumber: props.claimNumber,
        isInboxesActive: featureService.hasFeature(
          FEATURES.ATTRIBUTION_INBOXES_MANAGER,
        ),
        transactionId: props.transactionId,
        timelineId: props.timelineId,
        sagisEvaluations: !isNil(get(props, 'transactionId', null))
          ? getExpertiseSagisEvaluationTransaction(
              props.allExpertReport,
              [props.recap],
              props.responsibilityShare,
              props.victims,
              props.lossDate,
            )
          : {},
        provisionBody: !isNil(get(props, 'transactionId', null))
          ? {
              riskID: props.riskKey,
              date: moment().toISOString(true),
            }
          : {},
        isVehicle:
          Number(get(props.recap, 'mission.type', '')) ===
            EXPERTISE_MECHANIC_ID ||
          (Number(get(props.recap, 'mission.type', '')) ===
            EXPERTISE_ACCOUNTING_ID &&
            !isEmpty(get(props.recap, 'mission.missionVehicle', [])))
            ? true
            : false,
        missionId: get(props.recap, 'missionId'),
        isTrackingActive: featureService.hasFeature(
          FEATURES.TRACKING_ACTIONS_USER,
        ),
      },
      successCallBack,
    );
  };
  return (
    <DecisionDialog
      open={open}
      onClose={onClose}
      validateDialog={handleValidate}
      title={translate({ ...messages.decisionTitle }, props)}
      content={
        <StyledDiv>
          <TextField
            onChange={handleChangeComment}
            name={'comment'}
            value={comment}
            label={translate({ ...messages.comment }, props)}
            className="input"
            multiline
            fullWidth
          />
        </StyledDiv>
      }
      disabled={false}
      primaryButtonTitle={translate(messages.dialogValidationButton, props)}
      scondaryButtonTitle={translate(messages.dialogCancelButton, props)}
    />
  );
};

ValidationDialog.defaultProps = {
  open: false,
};

export default injectIntl(ValidationDialog);
